<router-outlet></router-outlet>
<div *ngIf="isReset">
    <app-reset-password></app-reset-password>
</div>

<div *ngIf="isDeleteAccount">
    <app-delete-user [iconUrl]="tenantConfiguration.iconUrl"></app-delete-user>
</div>